class QualityInputs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelector(".quality-inputs__minus").addEventListener("click", this.decrement.bind(this));
    this.querySelector(".quality-inputs__plus").addEventListener("click", this.increment.bind(this));
  }

  decrement() {
    const input = this.querySelector("input");
    input.value = parseInt(input.value) - 1;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  increment() {
    const input = this.querySelector("input");
    input.value = parseInt(input.value) + 1;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

if (!window.customElements.get("quality-inputs")) {
  window.customElements.define("quality-inputs", QualityInputs);
}